module.exports = __webpack_public_path__ + "static/media/grondstoffen.15869dde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/grondstoffen.svg
// module id = 803
// module chunks = 0